<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update customer</small>
      </legend>
      <div>
        <form @submit.prevent="customerUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="Customer.id" />
              <div class="form-group">
                <label>customer name</label>
                <input
                  type="text"
                  class="form-control customer_name input-rounded f-s-14"
                  :value="Customer.customer_name"
                  placeholder="customer name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Mobile number</label>
                <input
                  type="text"
                  class="form-control mobile_number input-rounded f-s-14"
                  :value="Customer.mobile_number"
                  placeholder="mobile number"
                 
                />
              </div>
              <div class="form-group">
                <label>Country</label>
                <input
                  type="text"
                  class="form-control country input-rounded f-s-14"
                  :value="Customer.country"
                  placeholder="country"
                  
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control email_address input-rounded f-s-14"
                  :value="Customer.email_address"
                  placeholder="email address"
                  
                />
              </div>
              <div class="form-group">
                <label>Address</label>
                <input
                  type="text"
                  class="form-control address input-rounded f-s-14"
                  :value="Customer.address"
                  placeholder="address"
                  
                />
              </div>
              <div class="form-group">
                <label>City</label>
                <input
                  type="text"
                  class="form-control city input-rounded f-s-14"
                  :value="Customer.city"
                  placeholder="city"
                  
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingCustomer btn-rounded">
            <i class="fa fa-refresh"></i> update customer
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingCustomerLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index"
export default {
    created(){
        if (this.$store.getters.Customer.length === 0) {
            router.push('/managecustomers');
        }
    },
    computed: {
        ...mapGetters(["Customer"])
    },
    methods: {
        ...mapActions(["customerUpdate"])
    }
    
}
</script>
<style scoped>
.updatingCustomerLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/customers/updatecustomer.vue